import { useState } from 'react'
import { MARBLE_STYLE_LABELS } from './game3d/constants'
import HowToPlay from './HowToPlay'
import DifficultyPicker from './DifficultyPicker'
import StarBoard from './StarBoard'
import { useGameStore } from '../stores/gameStore'
import { track } from '../utils/analytics'

interface MenuProps {
  onStartGame: () => void
  onBotBattle?: () => void
  onFeedback?: () => void
}

export const DIFFICULTY_OPTIONS = [
  { value: 'easy', label: 'Easy', accent: '#3f9d5a' },
  { value: 'medium', label: 'Medium', accent: '#e0a12a' },
  { value: 'hard', label: 'Hard', accent: '#d9772e' },
  { value: 'advanced', label: 'Advanced', accent: '#b0322a' },
]

export default function Menu({ onStartGame, onBotBattle, onFeedback }: MenuProps) {
  const { aiDifficulty, marbleStyle, setDifficulty } = useGameStore()
  const [showHowTo, setShowHowTo] = useState(false)
  const [showDifficulty, setShowDifficulty] = useState(false)

  return (
    <>
      <aside className="landing-sidebar">
        <div className="brand-lockup">
          <div className="menu-mark" aria-hidden="true">
            <StarBoard className="menu-mark-board" />
          </div>
          <div>
            {/* The one <h1> on the page. It reads as the full search phrase for
                crawlers while the spans keep "Chinese Checkers" as the visual mark. */}
            <h1 className="brand-title">
              <span className="brand-title-lead">Play</span>{' '}
              Chinese Checkers{' '}
              <span className="brand-title-tail">Online Against AI</span>
            </h1>
            <p>
              Play free against four levels of AI, from beginner to expert, or watch two
              computer players battle each other.
            </p>
          </div>
        </div>

        <nav className="sidebar-actions" aria-label="Game options">
          <button className="sidebar-primary" type="button" onClick={() => setShowDifficulty(true)}>
            Play
          </button>
          {onBotBattle && (
            <button className="sidebar-option" type="button" onClick={onBotBattle}>
              Bot Battle
            </button>
          )}
          <button className="sidebar-option" type="button" onClick={() => setShowHowTo(true)}>
            How to Play
          </button>
        </nav>

        <div className="sidebar-note">
          <span>Marble Style</span>
          <strong>{MARBLE_STYLE_LABELS[marbleStyle]}</strong>
          {onFeedback && (
            <button className="link-button sidebar-feedback" type="button" onClick={onFeedback}>
              Feedback / Suggest a feature
            </button>
          )}
        </div>
      </aside>

      {showHowTo && <HowToPlay onClose={() => setShowHowTo(false)} />}
      {showDifficulty && (
        <DifficultyPicker
          options={DIFFICULTY_OPTIONS}
          current={aiDifficulty}
          onClose={() => setShowDifficulty(false)}
          onPick={(value) => {
            track('difficulty_selected', { difficulty: value })
            setDifficulty(value)
            setShowDifficulty(false)
            onStartGame()
          }}
        />
      )}
    </>
  )
}
